export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "/as-autosuggest.worker.481ae254.js");
}
